var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 34,
    viewBox: "0 0 100 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.123047,
    width: 6.77148,
    height: 6.77148,
    fill: "#88898E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 13.6602,
    width: 6.77148,
    height: 20.3145,
    fill: "#88898E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0469,
    y: 0.123047,
    width: 6.77148,
    height: 6.77148,
    fill: "#88898E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 13.6602,
    width: 33.8193,
    height: 6.77148,
    fill: "#88898E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0469,
    y: 13.6719,
    width: 6.77148,
    height: 20.3027,
    fill: "#88898E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5234,
    y: 0.123047,
    width: 6.77148,
    height: 26.9043,
    fill: "#88898E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2741 25.0488V8.32155H57.8736C59.1423 8.32155 60.2231 8.56386 61.1161 9.04847C62.0091 9.52764 62.6897 10.1947 63.158 11.0495C63.6317 11.899 63.8686 12.8791 63.8686 13.9899C63.8686 15.1007 63.629 16.0808 63.1499 16.9302C62.6707 17.7797 61.9764 18.4412 61.0671 18.915C60.1632 19.3887 59.0688 19.6255 57.7837 19.6255H53.5774V16.7914H57.212C57.8926 16.7914 58.4535 16.6743 58.8945 16.4402C59.341 16.2006 59.6732 15.8712 59.891 15.4519C60.1142 15.0272 60.2259 14.5398 60.2259 13.9899C60.2259 13.4345 60.1142 12.9499 59.891 12.536C59.6732 12.1168 59.341 11.7928 58.8945 11.5641C58.448 11.33 57.8817 11.2129 57.1957 11.2129H54.8107V25.0488H51.2741ZM81.5372 16.6852C81.5372 18.5093 81.1914 20.0611 80.4999 21.3407C79.8138 22.6203 78.8773 23.5977 77.6903 24.2729C76.5087 24.9426 75.1801 25.2775 73.7045 25.2775C72.218 25.2775 70.8839 24.9399 69.7023 24.2647C68.5207 23.5895 67.5869 22.6122 66.9008 21.3326C66.2148 20.053 65.8717 18.5038 65.8717 16.6852C65.8717 14.8611 66.2148 13.3092 66.9008 12.0297C67.5869 10.7501 68.5207 9.77539 69.7023 9.10565C70.8839 8.43046 72.218 8.09286 73.7045 8.09286C75.1801 8.09286 76.5087 8.43046 77.6903 9.10565C78.8773 9.77539 79.8138 10.7501 80.4999 12.0297C81.1914 13.3092 81.5372 14.8611 81.5372 16.6852ZM77.9516 16.6852C77.9516 15.5036 77.7747 14.5072 77.4207 13.6958C77.0722 12.8845 76.5795 12.2692 75.9424 11.85C75.3053 11.4307 74.5593 11.2211 73.7045 11.2211C72.8496 11.2211 72.1036 11.4307 71.4665 11.85C70.8295 12.2692 70.334 12.8845 69.98 13.6958C69.6315 14.5072 69.4573 15.5036 69.4573 16.6852C69.4573 17.8668 69.6315 18.8632 69.98 19.6745C70.334 20.4859 70.8295 21.1011 71.4665 21.5204C72.1036 21.9397 72.8496 22.1493 73.7045 22.1493C74.5593 22.1493 75.3053 21.9397 75.9424 21.5204C76.5795 21.1011 77.0722 20.4859 77.4207 19.6745C77.7747 18.8632 77.9516 17.8668 77.9516 16.6852ZM86.0968 25.0488H82.307L88.0815 8.32155H92.639L98.4054 25.0488H94.6156L90.4256 12.144H90.2949L86.0968 25.0488ZM85.8599 18.4739H94.8116V21.2346H85.8599V18.4739Z",
    fill: "#88898E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoa);
export default __webpack_public_path__ + "static/media/poa.ad35039699892e5cbdf6dfc2cf7bc9b2.svg";
export { ForwardRef as ReactComponent };